import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, resolveMediaUrl } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function MessageDetail() {
  const { contactId } = useParams();
  const { user } = useAuth();
  const { t } = useLanguage();
  const [messages, setMessages] = useState([]);
  const [contact, setContact] = useState(null);
  const [text, setText] = useState('');
  const [file, setFile] = useState(null);

  const fetchMessages = async () => {
    if (!user?.id || !contactId) return;
    try {
      const response = await api.get('/api/messages', {
        params: { userId: user.id, contactId, page: 1, limit: 50 },
      });
      setMessages(response.data || []);
    } catch (err) {
      setMessages([]);
    }
  };

  const fetchContact = async () => {
    try {
      const response = await api.get(`/getUser/${contactId}`);
      setContact(response.data);
    } catch (err) {
      setContact(null);
    }
  };

  useEffect(() => {
    fetchMessages();
    fetchContact();
  }, [user?.id, contactId]);

  const handleSend = async (event) => {
    event.preventDefault();
    if (!text && !file) return;
    const formData = new FormData();
    formData.append('senderId', user.id);
    formData.append('receiverId', contactId);
    if (text) formData.append('message', text);
    if (file) formData.append('file', file);
    try {
      await api.post('/api/messages', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setText('');
      setFile(null);
      fetchMessages();
    } catch (err) {
      // ignore for now
    }
  };

  return (
    <div className="list">
      <div className="card">
        <h2 className="section-title">{contact?.nickName || t('messages.chatFallback')}</h2>
        <p className="section-subtitle">@{contact?.nickName}</p>
      </div>

      <div className="card list" style={{ maxHeight: 480, overflow: 'auto' }}>
        {messages.map((msg) => {
          const mine = `${msg.senderId}` === `${user?.id}`;
          const mediaUrl = resolveMediaUrl(msg.fileUrl);
          return (
            <div
              key={msg._id}
              style={{
                alignSelf: mine ? 'flex-end' : 'flex-start',
                background: mine ? 'rgba(249,115,22,0.2)' : 'rgba(15,23,42,0.8)',
                borderRadius: 16,
                padding: 12,
                maxWidth: '70%',
              }}
            >
              {msg.type === 'image' ? (
                <img src={mediaUrl} alt="attachment" style={{ width: '100%', borderRadius: 12 }} />
              ) : null}
              {msg.type === 'video' ? (
                <video src={mediaUrl} controls style={{ width: '100%' }} />
              ) : null}
              {msg.message ? <p style={{ margin: '8px 0 0' }}>{msg.message}</p> : null}
            </div>
          );
        })}
      </div>

      <form className="card list" onSubmit={handleSend}>
        <textarea
          className="input"
          rows="2"
          placeholder={t('messages.placeholder')}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <input className="input" type="file" accept="image/*,video/*" onChange={(e) => setFile(e.target.files[0])} />
        <button className="btn btn-primary" type="submit">
          {t('actions.send')}
        </button>
      </form>
    </div>
  );
}
